import { render, staticRenderFns } from "./TooltipEllipses.vue?vue&type=template&id=8dfc3814"
import script from "./TooltipEllipses.vue?vue&type=script&lang=js"
export * from "./TooltipEllipses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports